import React from "react";

export default function ListaAsignados({ asignados, ind, setRefresh, setTrash }) {
  function drag(e, u, indUsr) {
    // revisar, indUsr seria siempre 0...
    let data = { obj: "usuario", usuario: u, ind: ind, indUsr: indUsr }; // guardo la data del usuario
    e.dataTransfer.setData("text", JSON.stringify(data));
    setTrash(true);
    setRefresh((r) => !r);
  }

  return (
    <div>
      {asignados.length !== 0 ? (
        asignados.map((u, i) => {
          let Sfoto = {
            position: "absolute",
            top: (i * 2 + 6).toString() + "px",
            left: (i * 4).toString() + "px",
            clipPath: "circle(50%)",
          };
          return (
            <img
              id={"UU" + u.foto}
              src={u.url}
              alt="??"
              height="35px"
              width="35px"
              style={Sfoto}
              key={i}
              onDragStart={(e) => drag(e, u, i)}
              title={u.nombre}
            />
          );
        })
      ) : (
        <i className="material-icons icono32" style={SnoFoto}>
          person
        </i>
      )}
    </div>
  );
}

const SnoFoto = {
  position: "absolute",
  top: "10px",
  left: "10px",
};
